import type {IdentityVerificationSchema} from '../identityVerification';

export const getImageDetails = (state: IdentityVerificationSchema) => state.imagesDetails;
